$(function () {
  if (!customElements.get('home-bulletin-board')) {
    customElements.define(
      'home-bulletin-board',
      class homeBulletinBoard extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }

        init() {
          const $mySwiper = $(this).find('.mySwiper');
          const $slides = $(this).find('.swiper-slide');

          if ($slides.length > 1) {
            let maxHeight = 0;
            $slides.each(function () {
              const height = $(this).outerHeight();
              maxHeight = Math.max(maxHeight, height);
            });

            $mySwiper.height(maxHeight);

            const swiper = new Swiper($mySwiper[0], {
              loop: true,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              direction: 'vertical',
            });
          }
        }
      }
    );
  }
});
